<template>
  <div>
    <barraprincipal @abrir="mtMenuVisible"></barraprincipal>
    <menulateral @cerrar="mtMenuVisible" :value="menu_visible"> </menulateral>

    <v-container fluid>

        <div class="claro elevation-5">
            <v-row dense>     
                <v-col cols="12" md="12" class="d-flex align-center px-4">
                    <h2 class="primary--text">Mi perfil</h2>                    
                </v-col>                    
            </v-row>
        </div>      

        <br>  

        <v-row dense class="d-flex justify-space-between">
            <v-col cols="12" xs="12" sm="3">
                <v-text-field outlined dense label="Nombre *" v-model="nombre" :rules="[rules.required]"></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="3">
                <v-text-field outlined dense label="Apellido paterno *" v-model="apellido_paterno" :rules="[rules.required]"></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="3">
                <v-text-field outlined dense label="Apellido materno *" v-model="apellido_materno" :rules="[rules.required]"></v-text-field>
            </v-col>
        </v-row>

        <v-row dense class="d-flex justify-space-between">
            <v-col cols="12" xs="12" sm="3">
                <v-text-field outlined dense label="Número de control *" v-model="no_control" :rules="[rules.required, rules.min8]"></v-text-field>
            </v-col>

            <v-col cols="12" xs="12" sm="3">
                <v-text-field outlined dense label="Teléfono *" v-model="telefono" :rules="[rules.required, rules.min10]"></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="3">
                <v-text-field outlined dense label="Correo" v-model="correo" readonly></v-text-field>
            </v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" xs="12" sm="4">
                <v-select :items="carreras_itp" v-model="carrera" label="Carrera" outlined dense></v-select>
            </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="d-flex justify-end">
            <v-btn class="primary" @click="guardar()" :loading="guardando">Guardar</v-btn>
          </v-col>
        </v-row>

    </v-container>


    <!-- alertas -->
    <v-snackbar app timeout="4000" :color="skbcolor" v-model="skbvisible" light>
      <div class="d-flex justify-center"><b>{{skbtext}}</b></div>
    </v-snackbar>
  </div>
</template>

<script>

import menulateral from '@/components/MenuLateral'
import barraprincipal from '@/components/BarraPrincipal'


export default {
  components:{
    menulateral,
    barraprincipal
  },
  data() {
    return {
      calumno: null,
      menu_visible: false,

      skbtext: "",
      skbcolor: "success",
      skbvisible: false,

      carreras_itp: [],

      nombre: "",
      apellido_paterno: "",
      apellido_materno: "",
      no_control: "",
      telefono: "",
      correo: "",
      carrera: 6,

      rules: {
          required: value => !!value || 'Requerido.',
          min8: v => v.length >= 8 && v.length <= 9 || '8-9 caracteres',
          min10: v => v.length >= 10 && v.length <= 10 || '10 caracteres',
        },

      guardando: false,

    }
  },

  watch: {
      telefono() {
        this.telefono = this.telefono.replace(/[^0-9]/g, '')   
      },
      nombre(){
        this.nombre = this.nombre.charAt(0).toUpperCase() + this.nombre.slice(1)
      },
      apellido_paterno(){
        this.apellido_paterno = this.apellido_paterno.charAt(0).toUpperCase() + this.apellido_paterno.slice(1)
      },
      apellido_materno(){
        this.apellido_materno = this.apellido_materno.charAt(0).toUpperCase() + this.apellido_materno.slice(1)
      }
  },

  
  beforeCreate() {
    const token = sessionStorage.getItem('data')

    if(token == null)
      this.$router.push({name:'Login'})

    /* Consultar informacion del alumno */
    this.axios.get(this.$url+'/alumno/datos', {headers: {Authorization: `Bearer ${token}`}})
      .then((rs)=>{
        if(rs.data.error){
          console.log("Error al consultar información");
        }
        else{
          this.calumno = rs.data.calumno
          this.nombre = rs.data.nombre
          this.apellido_paterno = rs.data.apellido_paterno
          this.apellido_materno = rs.data.apellido_materno
          this.no_control = rs.data.no_control
          this.telefono = rs.data.telefono
          this.correo = rs.data.correo
          this.carrera = rs.data.ccarrera
        }
      })
      .catch((error)=>{
        console.log("Error "+ error);
      })

      this.guardando = true
      this.axios.get(this.$url+'/carreras', {headers: {Authorization: `Bearer ${token}`}})
            .then((response) => {
                for(let carrera of response.data){
                    this.carreras_itp.push({text: carrera.nombre, value: carrera.ccarrera})
                }

            })
            .catch(function (error) {
                console.log("Error");
                console.log(error);
            })
            .finally(()=>{
              this.guardando = false
            })

  },

  methods: {

    mtMenuVisible(value){
      this.menu_visible = value
    },

    validarParaGuardar(){
      if(this.nombre == '' || this.apellido_paterno == '' || this.apellido_materno == '' || this.no_control == '' || this.telefono == ''){
        return false
      }
      else{
        return true
      }
    },


    guardar(){
      const datos = {
        calumno: this.calumno,
        nombre: this.nombre.toUpperCase(),
        apellido_paterno: this.apellido_paterno.toUpperCase(),
        apellido_materno: this.apellido_materno.toUpperCase(),
        no_control: this.no_control,
        telefono: this.telefono,
        correo: this.correo,
        carrera: this.carrera
      }


      if(this.validarParaGuardar()){

        const token = sessionStorage.getItem('data')

        this.axios.post(this.$url+'/alumno/datos/actualizar', {datos}, {headers:{Authorization: `Bearer ${token}`}})
            .then((response)=>{
              if(response.data.error){
                this.skbtext = response.data.mensaje
                this.skbcolor = "error"
                this.skbvisible = true
              }
              else{
                this.skbtext = response.data.mensaje
                this.skbcolor = "success"
                this.skbvisible = true
              }
            })
      }
      else{
        this.skbtext = "Los datos marcados con * son requeridos."
        this.skbcolor = "error"
        this.skbvisible = true
      }
    }
  },



};

</script>